import React from "react";
import { useSelector } from "react-redux";
import { IRootState } from "../../../types/redux/IRootStore";
import { WorkorderManagementMaterial } from "../../../types/workorderManagementMaterial";
import { useTranslation } from "react-i18next";
import { parseChangeEvent } from "../../../aplUtils/formHelper";
import { useAppDispatch } from "../../../redux/hooks";
import { onSetWorkorderMaterialData, onSetWorkorderMaterialDataDirty, saveWorkordeManagementMaterialRedux } from "../../../redux/slices/workorderManagement.feature";
import FormInputText from "../../common/FormInputText";
import AplSettingsSelector from "../../../redux/helpers/AplSettingsSelector";
import FormInputNumber from "../../common/FormInputNumber";

export default function WorkorderManagementMaterialPane() {
    const { t } = useTranslation();
    const dispatch = useAppDispatch();
    const aplSetting = AplSettingsSelector();
    const onSubmit = async (e: any) => {
        e.preventDefault();
        if(workorderManagementRedux.orderMaterialData != null)
            dispatch(saveWorkordeManagementMaterialRedux(workorderManagementRedux.orderMaterialData) as any);
    };

    const onChange = (e: any) => {
        let data: WorkorderManagementMaterial = {
            ...workorderManagementRedux.orderMaterialData,
            ...parseChangeEvent(e)
        };
        dispatch(onSetWorkorderMaterialData(data));
        dispatch(onSetWorkorderMaterialDataDirty(true));
    };

    const workorderManagementRedux = useSelector((state: IRootState) => state.workorderManagement);

    return (
        <React.Fragment>
            <div className="container mw-100">
                <form onSubmit={onSubmit} onChange={onChange}>
                    <h5 className="mb-0">APLResource.Material</h5>
                    <div className="row" id="infoRow02">
                        <div className="col-4">
                            <label className="margin-bottom-02em" htmlFor="txtMaterialSapCode">
                                {t("main.litWomMaterial")}
                            </label>
                            <FormInputText name="materialSapCode" value={workorderManagementRedux.orderMaterialData?.materialSapCode} />
                        </div>

                        <div className="col-4">
                            <label htmlFor="txtMaterialDescription1" className="margin-bottom-02em">
                                {t("main.litWomDec1")}
                            </label>
                            <FormInputText name="description1" value={workorderManagementRedux.orderMaterialData?.description1} />
                        </div>

                        <div className="col-4">
                            <label className="margin-bottom-02em" htmlFor="txtEanGtin">
                                {t("main.litEANGTAN")}
                            </label>
                            <FormInputText name="eanCode" value={workorderManagementRedux.orderMaterialData?.eanCode} />
                        </div>
                    </div>

                    <div className="row">
                        {aplSetting.siteId > 0 && aplSetting.siteId <= 4 ? (
                            <div className="col-4" id="txtSpeakingMaterialNoRow">
                                <label className="margin-bottom-02em" htmlFor="textb0x-speakingPartNo">
                                    {t("main.material12")}
                                </label>
                                <FormInputText name="speakingPartNo" value={workorderManagementRedux.orderMaterialData?.speakingPartNo ?? ""} />
                            </div>
                        ) : null}

                        <div className="col-4">
                        <label className="margin-bottom-02em" htmlFor="textbox-containerVolume">
                                {t("main.containerVolume")}
                            </label>
                            <FormInputNumber
                                name="containerVolume"
                                value={workorderManagementRedux.orderMaterialData?.containerVolume}
                            />
                        </div>
                        <div className="col-4"></div>
                    </div>

                    <div>&nbsp;</div>

                    <div className="form-group row">
                        <div className="col-sm-10">
                            <div className="form-check form-check-inline">
                                <input
                                    className="form-check-input"
                                    type="checkbox"
                                    id="chkMaterialIgnoreSap"
                                    value="chkMaterialIgnoreSap"
                                    defaultChecked={workorderManagementRedux.orderMaterialData?.hasManualEdit}
                                    name="hasManualEdit"
                                />
                                <label className="form-check-label" htmlFor="chkMaterialIgnoreSap">
                                    {t("main.ignoreSapUpdates")}
                                </label>
                            </div>
                        </div>
                        <div className="col-sm-2">
                            <input
                                type="submit"
                                className="btn btn-primary float-right"
                                value={t("main.save")!}
                                disabled={!workorderManagementRedux.orderMaterialDataDirty}
                            />
                        </div>
                    </div>

                    <br />
                </form>
            </div>
        </React.Fragment>
    );
}
